import {Component} from '@angular/core';
import {NavController} from 'ionic-angular';
import {ComplementsPage} from '../../../profile/membership/complements';
import {SessionService} from '../../../../../services/session';
import {AuthService} from '../../../../../services/auth';
import {MembershipService} from '../../../profile/membership/membership.service';

@Component({
  selector: 'beauty-introduction',
  templateUrl: 'introduction.html',
})

export class BeautyIntroduction {
  beautyMembershipPage = ComplementsPage;
  price: number = undefined;

  constructor(
    public navCtrl: NavController,
    public sessionService: SessionService,
    public authService: AuthService,
    public membershipService:MembershipService,
  ) {
    this.loadPrice();
  }

  goTo(page){
    this.navCtrl.push(page);
  }

  async loadPrice() {
    console.debug('Loading price');
    await this.membershipService.getPrice();

    console.debug('Price loaded', this.membershipService.beautyPlans);

    if (this.membershipService.beautyPlans.length > 0) {
      this.price = this.membershipService.beautyPlans[0].price;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/beauty/find-beauty-class/introduction/introduction.ts